// removed by extract-text-webpack-plugin
module.exports = {"text-input":"styles-module__text-input___1BgcV","submit":"styles-module__submit___2icfY"};


//////////////////
// WEBPACK FOOTER
// ./src/import-modules/crossref/SeedSearchModal/styles.module.css
// module id = 1085
// module chunks = 0